import { Expose } from 'class-transformer';
import { BasicData } from '../basic/BasicData';

export class Point  {
    static readonly ModelFeatureAttribute = {
        CLASS_NAME: 'Point',
    };

    // @Expose()
    // id: string = '';

    @Expose()
    type: string = '';

    @Expose()
    title: string = '';

    @Expose()
    alt: string = '';

    // @Expose()
    // coordinates: [] = [];

    @Expose()
    lat: string = '';

    @Expose()
    lon: string = '';

    // @Expose()
    // command: string = '';

    // @Expose()
    // grad: string = '';

    @Expose()
    altDiff: string = '';

    @Expose()
    eastDiff: string = '';

    @Expose()
    northDiff: string = '';

    @Expose()
    distance: string = '';

    // @Expose()
    // azimuth: string = '';

    @Expose()
    ordinal: string = '';
}
